export default __webpack_public_path__ + "static/media/line-dotted.d921c88f.svg";